export default __webpack_public_path__ + "static/media/happy-new-year.8056a2bc.webp";